export enum XpressRiderDocumentVerificationStatusEnum {
	None = 0,
	ActionRequired = 1,
	Approved = 2,
	Rejected = 3,
}
